<template>

  <PageHeader
    title="Entity Management"
    subtitle="Configure entity types, create entities, manage relationships, user assignments, and set up classifiers"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template #bottom>
      <Page_Tabs
        class="px-6 pt-4"
        :tabs="tabs"
        no-border
      />
    </template>
  </PageHeader>

  <div class="entity-management-container p-4">
    <!-- Tab Content -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200">
      <EntityTypeConfiguration v-if="activeTab === 'configuration'" />
      <EntityCreator v-if="activeTab === 'creator'" />
      <UserEntityAssignments v-if="activeTab === 'user-assignments'" />
      <EntityRelationshipManager v-if="activeTab === 'relationships'" />
      <ClassificationManager v-if="activeTab === 'classification'" />
      <EntityScorecardMetrics v-if="activeTab === 'scorecard-metrics'" />
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle, faCogs, faUsers, faTags, faProjectDiagram, faPlus } from '@fortawesome/free-solid-svg-icons';
import EntityTypeConfiguration from '@/components/Entity/EntityTypeConfiguration.vue';
import UserEntityAssignments from '@/components/Entity/UserEntityAssignments.vue';
import ClassificationManager from '@/components/Entity/ClassificationManager.vue';
import EntityRelationshipManager from '@/components/Entity/EntityRelationshipManager.vue';
import EntityCreator from '@/components/Entity/EntityCreator.vue';
import EntityScorecardMetrics from '@/components/Entity/EntityScorecardMetrics.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

library.add(faInfoCircle, faCogs, faUsers, faTags, faProjectDiagram, faPlus);

export default {
  name: 'EntityManagementContainer',
  components: {
    EntityTypeConfiguration,
    UserEntityAssignments,
    ClassificationManager,
    EntityRelationshipManager,
    EntityCreator,
    EntityScorecardMetrics,
    PageHeader,
    Page_Tabs
  },
  computed: {
    tabs() {
      return [
        {
          key: 'configuration',
          label: 'Entity Configuration',
          icon: ['fas', 'cogs'],
          description: 'Define entity types, manage their attributes, and configure display components',
          to: '/tenantadmin/entity-management/configuration',
        },
        {
          key: 'creator',
          label: 'Entity Creator',
          icon: ['fas', 'plus'],
          description: 'Manually create new entities with custom attributes and relationships',
          to: '/tenantadmin/entity-management/creator',
        },
        {
          key: 'user-assignments',
          label: 'User Assignments',
          icon: ['fas', 'users'],
          description: 'Assign entity types to users and manage user-entity relationships',
          to: '/tenantadmin/entity-management/user-assignments',
        },
        {
          key: 'relationships',
          label: 'Relationship Manager',
          icon: ['fas', 'project-diagram'],
          description: 'Manage parent-child relationships between entities',
          to: '/tenantadmin/entity-management/relationships',
        },
        {
          key: 'classification',
          label: 'Classification Management',
          icon: ['fas', 'tags'],
          description: 'Create and manage entity classifiers using AI-powered InfoTagTypes',
          to: '/tenantadmin/entity-management/classification',
        },
        {
          key: 'scorecard-metrics',
          label: 'Key Metrics Config',
          icon: ['fas', 'cogs'],
          description: 'Configure which key metrics display for specific entities',
          to: '/tenantadmin/entity-management/scorecard-metrics',
        },
      ];
    },
    activeTab() {
      return this.$route.meta.entityConfigurationTab || 'configuration';
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
